import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import {
  AppInitializerFacade,
  AppResponseWithStatus,
  HttpRequestStatus,
} from '@cpm-pr1618003/ng-initializer-lib';
import { Observable, catchError, filter, map, of, take, timeout } from 'rxjs';

const AUTH_GUARD_TIMEOUT_MS = 10000;

export const authGuardFn: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
):
  | Observable<boolean | UrlTree>
  | Promise<boolean | UrlTree>
  | boolean
  | UrlTree => {
  const facade = inject(AppInitializerFacade);

  return facade.appResponse$.pipe(
    filter(
      (value: AppResponseWithStatus | null | undefined) =>
        !!value &&
        (value.appInitializerRequestStatus === HttpRequestStatus.Success ||
          value.appInitializerRequestStatus === HttpRequestStatus.Failed),
    ),
    map((value: AppResponseWithStatus) => !!value.isAppValid),
    take(1),
    timeout(AUTH_GUARD_TIMEOUT_MS),
    catchError(() => of(false)),
  );
};
